import type React from 'react';

import type { PropsWithTestId } from '../types';

interface StatesProps {
    icon?: React.ReactNode;
    onDark?: boolean;
    title: string;
    body: React.ReactNode | string;
    button: React.ReactNode;
}

const States = ({ button, title, body, icon, onDark, 'data-testid': dataTestId }: PropsWithTestId<StatesProps>) => (
    <div data-testid={dataTestId} className={`InfoBlock ${onDark ? 'InfoBlock--onDark' : ''}`}>
        {icon}
        <p className='InfoBlock__title'>{title}</p>
        <div className='InfoBlock__body'>{body}</div>
        <div className='InfoBlock__actions'>{button}</div>
    </div>
);

export default States;
